import { PlayerClassType } from "../../enum/PlayerClassType";
import { MetersToUnits, toPixels } from "../../util";
import Player from "../Player";
import PlayerClass from "../PlayerClass";
import Gun from "../Gun";
import Fortify from "../abilities/tank/Fortify";
import GravityWell from "../abilities/tank/GravityWell";
import Countercharge from "../abilities/tank/Countercharge";
import HeavyCannon from "../guns/tank/HeavyCannon";
import FlakDisperser from "../guns/tank/FlakDisperser";

export default class Tank extends PlayerClass {

    constructor(player: Player) {
        super(PlayerClassType.Tank, player, new HeavyCannon(player), new FlakDisperser(player));

        this.player.hp = this.player.maxHp = 1200;
        this.player.energy = this.player.maxEnergy = 120;
        this.player.accelerationForce = toPixels(MetersToUnits(80));
        this.player.size = 12;

        this.abilities = [
            new Fortify(this.player),
            new GravityWell(this.player),
            new Countercharge(this.player)
        ];
    }

    Draw(color: string): void {
        this.ctx.strokeStyle = color;
        this.ctx.fillStyle = color + "55";
        this.ctx.lineWidth = 1;

        //draw player
        const p1 = this.player.transform.position.add(this.player.transform.forward.scale(this.player.size));
        const p2 = this.player.transform.position.add(this.player.transform.right.rotate(Math.PI/5).scale(this.player.size));
        const p3 = this.player.transform.position.add(this.player.transform.back.scale(this.player.size));
        const p4 = this.player.transform.position.add(this.player.transform.left.rotate(-Math.PI/5).scale(this.player.size));

        this.player.engine.fillShape(p1, p2, p3, p4);
        this.player.engine.strokeShape(p1, p2, p3, p4);

        if (this.player.damageReductionModifier > 0) {
            const p1 = this.player.transform.position.add(this.player.transform.forward.scale(this.player.size + 3));
            const p2 = this.player.transform.position.add(this.player.transform.right.rotate(Math.PI/5).scale(this.player.size + 3));
            const p3 = this.player.transform.position.add(this.player.transform.back.scale(this.player.size + 3));
            const p4 = this.player.transform.position.add(this.player.transform.left.rotate(-Math.PI/5).scale(this.player.size + 3));

            this.player.engine.fillShape(p1, p2, p3, p4);
            this.player.engine.strokeShape(p1, p2, p3, p4);
        }
        //

        super.Draw(color);
    }

}